module.exports = __webpack_public_path__ + "img/SentimentVeryDissatisfiedOutlined.18c0f8d3.svg";